export default "__VITE_ASSET__e24b8e23__"